import "./Notification.css";
import React, { useEffect } from "react";
import "./Notification.css";

const Notification = ({ notification, onClose }) => {
  useEffect(() => {
    // Auto-fermer la notification après 5 secondes
    const timer = setTimeout(() => {
      onClose();
    }, 5000);

    return () => clearTimeout(timer);
  }, [onClose]);

  const getIcon = () => {
    switch (notification.type) {
      case "success":
        return "✅";
      case "error":
        return "❌";
      case "warning":
        return "⚠️";
      default:
        return "ℹ️";
    }
  };

  const getClassName = () => {
    return `notification notification-${notification.type}`;
  };

  return (
    <div className={getClassName()}>
      <div className="notification-content">
        <span className="notification-icon">{getIcon()}</span>
        <div className="notification-text">
          {notification.passengerName && (
            <p className="notification-title">
              <strong>Message pour {notification.passengerName} :</strong>
            </p>
          )}
          <p className="notification-message">{notification.message}</p>
        </div>
        <button className="notification-close" onClick={onClose}>
          ×
        </button>
      </div>
    </div>
  );
};

export default Notification;
